import * as Immutable from "immutable";
import { getResource } from "selectors/resources";
import { Features } from "resourceModels/Client";
import BaseMessageRecord, {
  BaseMessageRecordAttributes,
  BlockConfigGetter
} from "../BaseMessageRecord";

interface DeauthMessageRecordAttributes extends BaseMessageRecordAttributes {
  type: "sign_out";
  authProvider: string;
}

class DeauthMessageRecord extends BaseMessageRecord<DeauthMessageRecordAttributes>({
  type: "sign_out",
  authProvider: ""
}) {
  static blockConfig: BlockConfigGetter = (state) => {
    const client = getResource(state, "client");
    const { auths } = state;

    return ({
      blockType: "action",
      isVisible: (
        !client.hasFeature(Features.ZENDESK_CLIENT) &&
        !client.hasFeature(Features.LIVEPERSON_CLIENT) &&
        client.hasFeature(Features.PERSONALIZATION) &&
        (Boolean(auths.size) || client.hasFeature(Features.AUTHENTICATION))
      ),
      blockName: "Request Sign Out",
      blockTitle: "Request Sign Out",
      shortTitle: "Sign Out",
      icon: "SignOut"
    });
  };

  static getInvalidFields = (message: DeauthMessageRecord): Immutable.List<string> => {
    const invalidFields: Set<string> = new Set();

    if (message.authProvider.length <= 0) {
      invalidFields.add("authProvider");
    }

    return Immutable.List(invalidFields);
  };
}

export default DeauthMessageRecord;
